import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/chemistry/elements/components/x-hr.js';
import '@adornis/chemistry/elements/components/x-icon.js';
import { XToggleContent } from '@adornis/chemistry/elements/components/x-toggle-content.js';
import { xComponents } from '@adornis/chemistry/elements/x-components.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * @element tr-toggle-content
 */
@customElement('tr-toggle-content')
export class TrToggleContent extends XToggleContent {
  @property({ type: Boolean }) compact = false;

  override _labelWrapper() {
    if (!this.compact) return super._labelWrapper();
    return xComponents(html`
      <x-flex
        horizontal
        crossaxis-center
        space="sm"
        ${css({ cursor: 'pointer', userSelect: 'none' })}
        @click="${() => {
          this.open = !this.open;
          if (!this.open) this.blur();
        }}"
      >
        ${this._label()}
      </x-flex>
    `);
  }

  override _label() {
    if (!this.compact) return super._label();
    return xComponents(html`
      ${typeof this.label === 'string' ? html` <x-h4 flex> ${this.label} </x-h4> ` : this.label} ${this.icon()}
    `);
  }

  protected override _contentWrapper() {
    if (!this.compact) return super._contentWrapper();
    return html`
      <x-flex
        id="content"
        space="xs"
        ${css({
          paddingTop: this.spacing.xs,
          ...(this.open
            ? { height: 'unset' }
            : { height: '0', opacity: '0', pointerEvents: 'none', overflow: 'hidden', display: 'none' }),
        })}
      >
        <x-hr></x-hr>
        ${super._content()}
      </x-flex>
    `;
  }

  override icon() {
    if (!this.compact) return super.icon();
    return xComponents(html`
      <x-icon ${css({ color: this.colors.accent, fontSize: '1em', marginLeft: 'auto' })}>
        ${this.open || this.isPrinting.value ? 'expand_more' : 'chevron_right'}
      </x-icon>
    `);
  }
}
